// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQItem_wrapper__568H-","texts":"FAQItem_texts__gIO57","btn":"FAQItem_btn__IZw5W","answer":"FAQItem_answer__9WSh4","open":"FAQItem_open__Imfia"};